import { render, staticRenderFns } from "./CompanySettingsForm.vue?vue&type=template&id=35802d6c&scoped=true&"
import script from "./CompanySettingsForm.vue?vue&type=script&lang=ts&"
export * from "./CompanySettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35802d6c",
  null
  
)

export default component.exports